<template>
  <div class="tab-bar-item" :style="activeBgStyle" @click="itemClick">
    <div class="item" :style="opacity">
      <div v-if="!isActive"><slot name="item-icon"></slot></div>
      <div v-else><slot name="item-icon-active"></slot></div>
      <div :style="activeStyle"><slot name="item-text"></slot></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabBarItem',
  props: {
    path: String,
    activeColor: {
      type: String,
      default: 'red'
    },
    activeBgColor: {
      type: String,
      default: 'red'
    }
  },
  computed: {
    isActive() {
      return this.$route.path.indexOf(this.path) !== -1
    },
    activeStyle() {
      return this.isActive ? {color: this.activeColor} : {}
    },
    activeBgStyle() {
      return this.isActive ? {backgroundColor: this.activeBgColor} : {}
    },
    opacity() {
      return this.isActive ? {opacity: 1} : {}
    }
  },
  methods: {
    itemClick() {
      this.$router.push('/pc'+this.path)
    }
  },
};
</script>

<style scoped>
.tab-bar-item {
  flex: 1;
  text-align: center;
  height: 83px;
  font-size: 14px;
  background-color: rgba(0, 0, 0, 0.8);
  margin: 5px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.item {
  color: #ffaf31;
  opacity: 0.6;
}
.tab-bar-item .item img {
  height: 39px;
  vertical-align: middle;
}
.tab-bar-item .item .item-text {
  font-size: 18px;
}
</style>